//import { persistReducer } from 'redux-persist';
//import storage from 'redux-persist/lib/storage'
import { AllowedAction } from 'api';
import {
	API_ERROR,
	GET_ALLOWED_ACTIONS,
	SET_ALLOWED_ACTIONS,
	SIGNUP_INIT,
	SIGNUP_USER,
	SIGNUP_USER_SUCCESS
} from './actionTypes';

interface ILoginStore {
	loginError?: string;
	message?: string | null;
	loading?: boolean;
	signup: boolean;
	allowedActions?: AllowedAction[];
}

const initialState: ILoginStore = {
	loginError: undefined,
	message: null,
	loading: false,
	signup: false,
	allowedActions: []
};

const login = (state = { ...initialState }, action: any) => {
	switch (action.type) {
		case SIGNUP_INIT:
			state = {
				...state,
				loading: true,
				signup: false
			};
			break;
		case SIGNUP_USER:
			state = {
				...state,
				loading: true,
				signup: false
			};
			break;
		case SIGNUP_USER_SUCCESS:
			state = {
				...state,
				loading: false,
				signup: true
			};
			break;
		case GET_ALLOWED_ACTIONS:
			state = {
				...state,
				loading: true
			};
			break;
		case SET_ALLOWED_ACTIONS:
			state = {
				...state,
				allowedActions: [...action.payload],
				loading: false
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
				loginError: action.payload
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};
/*const loginPersistConfig = {
    key: 'user',
    storage,
}*/

//export default persistReducer(loginPersistConfig, login);
export default login;
